import type { ClientEnvironment } from 'bc-model';
import type { MetricsAdapter, TimeSeriesMetricsAdapter } from '../Metrics';
import consoleAdapter from './consoleAdapter';
import faroAdapter from './faroAdapter';
import performanceMarksAdapter from './performanceMarksAdapter';
import promTimeSeriesAdapter from './promTimeSeriesAdapter';

type AdapterFactory = (env: ClientEnvironment) => MetricsAdapter | Promise<MetricsAdapter>;

const adapterMap: Record<string, AdapterFactory> = {
  performanceMarks: () => performanceMarksAdapter(),
  console: () => consoleAdapter(),
  faro: (env) => faroAdapter(env),
};

const timeSeriesAdapterMap: Record<string, () => TimeSeriesMetricsAdapter> = {
  prom: () => promTimeSeriesAdapter(),
};

export { adapterMap, timeSeriesAdapterMap };
